import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { swedish } from "./lang/sv-se";
import { english } from "./lang/en-us";
import { LOCALES } from "common/constants";

let retrievedLanguage = (localStorage.getItem("i18nextLng"))?.toLowerCase() || LOCALES.SV_SE;

if (![LOCALES.EN_US, LOCALES.SV_SE].includes(retrievedLanguage)) {
  retrievedLanguage = LOCALES.SV_SE;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      [LOCALES.EN_US]: english,
      [LOCALES.SV_SE]: swedish,
    },
    fallbackLng: LOCALES.EN_US,
    lowerCaseLng: true,
    debug: false,
    lng: retrievedLanguage,
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
